// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"10834c56","42":"a1f601ba","638":"8f35b6c1","695":"2a402a0e"}[chunkId] + ".chunk.js";
};